import { Component } from '@angular/core';
import { PageContent } from "../../shared/page-content/page-content.component";
import { RouterLink } from '@angular/router';
import { OfferingCard } from './offering-card/offering-card.component';
import { PriorityCard } from './priority-card/priority-card.component';

@Component({
  selector: 'app-home',
  imports: [
    PageContent,
    RouterLink,
    OfferingCard,
    PriorityCard
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class Home {

}
